import { t } from '@lingui/core/macro';

import { useEventLogTypes } from '@/api/eventLog';
import {
  CategoryFilter,
  ComboboxPickerFilter,
  encodeFilterFieldName,
  FilterField,
  useFilterForm,
} from '@/components/filters';
import type { FilterOperatorMulti } from '@/components/InstantSearch';
import { usePageFilterContext } from '@/components/page/PageFilters';
import type { FilterComponentProps } from '@/providers/TableState';

type Props = FilterComponentProps & {
  mode?: 'multiple';
};

const EventTypeFilter = ({
  name,
  label,
  infoPopover,
  compact = false,
  mode = 'multiple',
  ...props
}: Props) => {
  const form = useFilterForm();
  const { pageFilters } = usePageFilterContext();
  const { startDate, endDate } = pageFilters;
  const { eventTypes, isLoading, error } = useEventLogTypes(startDate, endDate);

  return (
    <form.AppField name={encodeFilterFieldName(name)}>
      {(field) => (
        <FilterField
          data-testid="event-type-filter"
          label={label}
          infoPopover={infoPopover}
          hideLabel={!compact}
        >
          {compact ? (
            <ComboboxPickerFilter
              {...props}
              value={field.state.value as FilterOperatorMulti}
              onChange={field.handleChange}
              mode={mode}
              singlePlaceholder={t`Select Event Type...`}
              multiplePlaceholder={t`Select Event Types...`}
              multipleLoadingPlaceholder={t`Loading Event Types...`}
              filteredItems={eventTypes}
              isLoading={isLoading}
              error={error}
              notFoundContent={t`No event types were found...`}
            />
          ) : (
            <CategoryFilter
              {...props}
              value={field.state.value as FilterOperatorMulti}
              onChange={field.handleChange}
              selectionMode={mode}
              isLoading={isLoading}
              error={error}
              options={eventTypes}
            />
          )}
        </FilterField>
      )}
    </form.AppField>
  );
};

export default EventTypeFilter;
